'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import { Networks } from 'AdsUI/lib/Constants';
import { fetchTrackingStatusesForAdGroup } from 'AdsUI/data/TrackingStatusData';
import useTrackingErrorModal from 'AdsUI/lib/useTrackingErrorModal';
import BaseTrackingErrorModal from 'AdsUI/components/tracking-error-modal/BaseTrackingErrorModal';

const AdGroupTrackingErrorModal = ({
  accountId,
  adGroupId,
  campaignId,
  name,
  network,
  onClose
}) => {
  const fetchStatuses = useCallback(() => fetchTrackingStatusesForAdGroup(network, accountId, campaignId, adGroupId), [network, accountId, campaignId, adGroupId]);
  const {
    loading,
    groupedStatuses
  } = useTrackingErrorModal(fetchStatuses);
  return /*#__PURE__*/_jsx(BaseTrackingErrorModal, {
    onClose: onClose,
    groupedStatuses: groupedStatuses,
    loading: loading,
    name: name
  });
};

AdGroupTrackingErrorModal.propTypes = {
  accountId: PropTypes.string.isRequired,
  adGroupId: PropTypes.string.isRequired,
  campaignId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  network: PropTypes.oneOf(Object.keys(Networks)).isRequired,
  onClose: PropTypes.func.isRequired
};
export default AdGroupTrackingErrorModal;